module.exports = __webpack_public_path__ + "img/P150T_weapon_25.a99bd8bb.png";